var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.modeCreate && _vm.dataMaster.name === "analytic"
        ? _c(
            "b-card",
            { staticClass: "card-board m__b--60" },
            [
              _c("j-analytic-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeMode }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.modeCreate && _vm.dataMaster.name === "analytic_v2"
        ? _c(
            "b-card",
            { staticClass: "card-board m__b--60" },
            [
              _c("j-analytic2-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeMode }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.modeCreate && _vm.dataMaster.name === "attendance"
        ? _c(
            "b-card",
            { staticClass: "card-board m__b--60" },
            [
              _c("j-attendance-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeMode }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.modeCreate && _vm.dataMaster.name === "channel"
        ? _c(
            "b-card",
            { staticClass: "card-board m__b--60" },
            [
              _c("j-channel-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeMode }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.modeCreate && _vm.dataMaster.name === "discussion"
        ? _c(
            "b-card",
            { staticClass: "card-board m__b--60" },
            [
              _c("j-discussion-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeMode }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.modeCreate && _vm.dataMaster.name === "html"
        ? _c(
            "b-card",
            { staticClass: "card-board m__b--60" },
            [
              _c("j-html-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeMode }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.modeCreate && _vm.dataMaster.name === "timesheet"
        ? _c(
            "b-card",
            { staticClass: "card-board m__b--60" },
            [
              _c("j-timesheet-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeMode }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.modeCreate &&
      _vm.dataMaster.name === "digital_signature_register_peruri"
        ? _c(
            "b-card",
            { staticClass: "card-board m__b--60" },
            [
              _c("j-register-peruri-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeMode }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.modeCreate && _vm.dataMaster.name === "digital_signature_sign"
        ? _c(
            "b-card",
            { staticClass: "card-board m__b--60" },
            [
              _c("j-sign-document-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeMode }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.modeCreate && _vm.dataMaster.name === "digital_signature_document"
        ? _c(
            "b-card",
            { staticClass: "card-board m__b--60" },
            [
              _c("j-status-document-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeMode }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.modeCreate && _vm.dataMaster.name === "digital_signature_upload"
        ? _c(
            "b-card",
            { staticClass: "card-board m__b--60" },
            [
              _c("j-upload-document-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeMode }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.modeCreate && _vm.dataMaster.name === "create_record"
        ? _c(
            "b-card",
            { staticClass: "card-board m__b--60" },
            [
              _c("j-create-record-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeMode }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.modeCreate && _vm.dataMaster.name === "todo_task"
        ? _c(
            "b-card",
            { staticClass: "card-board m__b--60" },
            [
              _c("j-todo-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeMode }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.modeCreate && _vm.dataMaster.name === "quota_leave"
        ? _c(
            "b-card",
            { staticClass: "card-board m__b--60" },
            [
              _c("j-quota-leave-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeMode }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.modeCreate && _vm.dataMaster.name === "leave_all_employee"
        ? _c(
            "b-card",
            { staticClass: "card-board m__b--60" },
            [
              _c("j-leave-all-employee-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeMode }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.modeCreate && _vm.dataMaster.name === "experience_manager"
        ? _c(
            "b-card",
            { staticClass: "card-board m__b--60" },
            [
              _c("j-experience-manager-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeMode }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.modeCreate && _vm.dataMaster.name === "embed_url"
        ? _c(
            "b-card",
            { staticClass: "card-board m__b--60" },
            [
              _c("j-embed-url-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeMode }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.modeCreate && _vm.dataMaster.name === "qrcode_scanner"
        ? _c(
            "b-card",
            { staticClass: "card-board m__b--60" },
            [
              _c("jQRCodeSetup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeMode }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.modeCreate && _vm.dataMaster.name === "shortcut_page"
        ? _c(
            "b-card",
            { staticClass: "card-board m__b--60" },
            [
              _c("j-shortcut-page-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeMode }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-69f588ac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69f588ac","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/widget/jWidgetComponentCreate.vue
// module id = null
// module chunks = 